import * as angular from 'angular';

import { IHorizontalBarChart, Group } from '../../models';
import { HorizontalBarChart } from '../horizontalBarChart/horizontalBarChart.controller';
import { refreshClick, groupSelected, connectionPointSelected } from '../../common/';

export interface IBadActors extends IHorizontalBarChart {
    isLoading: boolean;
    isLoaded: boolean;
}

export class BadActorsBase extends HorizontalBarChart implements IBadActors {
    isLoading: boolean;
    isLoaded: boolean;
    
    private _guid: string;
    private _scope: angular.IScope;

    constructor($scope: angular.IScope) {
        super($scope);
        this._scope = $scope;

    }

    $onInit() {
        super.$onInit();
        const self = this;
        this._scope.$on(refreshClick, self.refresh());
        this._scope.$on(groupSelected, (event, group: Group) => {
            self.readData(group.guid);
        });
        this._scope.$on(connectionPointSelected, (event, connectionPointGuid: string) => {
            self.readData(connectionPointGuid);
        });
    }

    readData(guid?: string) {
        throw new Error('This method is abstract and has to be overwritten');
    }

    private refresh() {
        const self = this;
        return () => {
            self.readData(self._guid);
        };
    }
}